// ¿Estoy viendo la versión que acabo de subir?
//
// POR QUÉ EXISTE
//
// Dos veces pasó lo mismo: "agregué X y no aparece". Las dos veces el
// código estaba bien y el bundle compilado tenía la función. Lo que no
// se podía saber desde afuera era cuál de estos tres problemas era —
// tienen la misma cara y soluciones distintas:
//
//   1. No se desplegó (falta el push, o Railway todavía está armando)
//   2. Se desplegó pero el build falló y quedó el anterior
//   3. Se desplegó bien y el navegador tiene una copia vieja
//
// CRA le pone al bundle un hash de su contenido (main.71bfbbf7.js), así
// que el nombre ES la versión. Comparar el que sirve el servidor con el
// que cargó el navegador distingue los tres casos de un vistazo.
//
// Vive en el perfil y no en un rincón escondido: cuando hace falta,
// hace falta rápido.

import { useEffect, useState } from "react";
import { API_URL } from "./api";
import { t, tError, idiomaActual, useIdioma } from "./i18n";

// El bundle que ESTE navegador cargó, leído del propio DOM. No hay otra
// forma de saberlo desde adentro: `process.env` se congela al compilar
// y diría lo que era cierto en la máquina que compiló, no acá.
function bundleDelNavegador() {
  const script = document.querySelector('script[src*="/static/js/main."]');
  if (!script) return null;
  try {
    return new URL(script.src).pathname;
  } catch {
    return script.getAttribute("src");
  }
}

/* Cuánto hace que arrancó el servidor, dicho por `Intl`.
 *
 * Antes eran tres ramas con "segundos", "minutos" y "horas" escritas a
 * mano. Con doce idiomas eso son 36 palabras y varias reglas de plural
 * que ninguna tabla acierta sola: el árabe tiene dual, el japonés no
 * pluraliza, el ruso tiene tres formas. `Intl` las sabe todas. */
function haceCuantoArranco(segundos, idioma) {
  const rel = new Intl.RelativeTimeFormat(idioma, { numeric: "auto" });
  if (segundos < 120) return rel.format(-segundos, "second");
  if (segundos < 7200) return rel.format(-Math.round(segundos / 60), "minute");
  return rel.format(-Math.round(segundos / 3600), "hour");
}

export default function Version() {
  useIdioma();
  const [salud, setSalud] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${API_URL}/api/health`)
      .then((r) => r.json())
      .then(setSalud)
      .catch((e) => setError(tError(e)));
  }, []);

  const mio = bundleDelNavegador();

  // En desarrollo el bundle lo sirve react-scripts y no hay manifiesto:
  // no hay nada que comparar, y decirlo es más honesto que mostrar dos
  // guiones y dejar pensando.
  const sinBuild = salud && !salud.bundle;
  const coinciden = salud?.bundle && mio && salud.bundle === mio;

  return (
    <div className="version">
      {error && <p className="texto-mini mensaje-error" role="alert">{error}</p>}

      {salud && (
        <>
          <p className="texto-mini tenue" style={{ margin: 0 }}>
            {/* El "hace N segundos" lo arma Intl y no un ternario con
                las tres palabras escritas: así sale bien en los doce
                idiomas, incluidos los que tienen dual o no dicen
                "hace". */}
            {t("version.arranco", "El servidor arrancó {cuando}.", {
              cuando: haceCuantoArranco(salud.segundosVivo, idiomaActual()),
            })}
          </p>

          {sinBuild ? (
            <p className="texto-mini tenue" style={{ margin: 0 }}>
              {t("version.modoDesarrollo", "Modo desarrollo: el código lo sirve react-scripts.")}
            </p>
          ) : coinciden ? (
            <p className="texto-mini version-ok" style={{ margin: 0 }}>
              {t("version.alDia", "Estás viendo la última versión desplegada.")}
            </p>
          ) : (
            <>
              <p className="texto-mini version-vieja" style={{ margin: 0 }}>
                {t("version.copiaVieja", "Tu navegador tiene una copia vieja. Refresca con Ctrl+Shift+R.")}
              </p>
              <p className="texto-mini tenue" style={{ margin: 0 }}>
                {t("version.servidorYTuyo", "Servidor: {servidor} · Tú: {tuyo}", {
                  servidor: salud.bundle,
                  tuyo: mio || t("version.noSePudoLeer", "no se pudo leer"),
                })}
              </p>
            </>
          )}
        </>
      )}
    </div>
  );
}
